



























































import { defineComponent, ref, computed } from "@vue/composition-api";
import { BModal, BFormInput, BFormCheckbox, BButton, BFormSelect, BInputGroup } from "bootstrap-vue";
import useUsers from "./useUsers";

export default defineComponent({
    components: {
        BModal,
        BFormInput,
        BFormCheckbox,
        BButton,
        BFormSelect,
        BInputGroup,
    },
    setup() {
        const {
            prices,
            billingMonths,
            fetchLimits,
            fetchPrices,
            increaseLimits,
            requestIncreaseLimits,
            isLoadingLimits,
        } = useUsers();

        fetchLimits();
        fetchPrices();

        const newUserAmount = ref(1);

        const tosAgreed = ref(false);

        const userPrice = computed(() => (prices.value?.[billingMonths.value!] ?? 0) / 100);

        const totalPrice = computed(() => newUserAmount.value * userPrice.value);
        const canCreateNewUsers = computed(() => userPrice.value >= 0);

        const localIncreaseLimits = async () => {
            if (!canCreateNewUsers.value) {
                await requestIncreaseLimits({ newUsers: newUserAmount.value });
                return;
            }

            isLoadingLimits.value = true;

            await increaseLimits({
                tosAgree: tosAgreed.value,
                newUsers: newUserAmount.value,
            });

            await fetchLimits(true);
        };

        const formatUsers = (usersString: string): string => {
            const users = Number(usersString);

            if (users > 100) {
                return "100";
            }

            if (usersString === "") {
                return "";
            }

            if (users < 1) {
                return "1";
            }

            if (!Number.isInteger(users)) {
                return String(Math.round(users));
            }

            return usersString;
        };

        return {
            newUserAmount,
            prices,
            totalPrice,
            tosAgreed,
            userPrice,
            formatUsers,
            localIncreaseLimits,
            increaseLimits,
            canCreateNewUsers,
        };
    },
});
